import React, { useState, useEffect } from "react";
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

const ShipmentUpdateFlag = ({ updateFlag = false, onCreateFlag = false, onCloseFlag = true, updateCallBack = null, message = null }) => {

    const handleChange = (event, type) => {
        let updateValue = {
            "is_update_shipment": updateFlag,
            "is_update_shipment_on_create": onCreateFlag,
            "is_update_shipment_on_close": onCloseFlag
        }
        if (type === "switch") {
            updateValue.is_update_shipment = event.target.checked
        }else if (type === "radio") {
            updateValue.is_update_shipment_on_create = (event.target.value === "create_shipment") ? true : false;
            updateValue.is_update_shipment_on_close = (event.target.value === "manifest_close") ? true : false;
        }
        updateCallBack(updateValue)
    };

    return (
        <>
            <Box 
                className="sc--form--center"
                sx={{ 
                    width: '100%', 
                    maxWidth: '560px', 
                    mx: 'auto', 
                    my: 2,
                    boxSizing: 'border-box'
                }}
            >
                <Card 
                    sx={{ 
                        backgroundColor: '#FFFFFF',
                        border: '1px solid #E2E8F0',
                        borderRadius: '14px',
                        boxShadow: '0 4px 6px -1px rgba(15, 23, 42, 0.02), 0 2px 4px -1px rgba(15, 23, 42, 0.01)',
                        overflow: 'hidden'
                    }}
                >
                    <CardContent sx={{ p: 3.5, '&:last-child': { pb: 3.5 } }}>
                        <FormGroup sx={{ width: '100%' }}>
                            
                            {/* Toggle Switch Component Controller Row Section */}
                            <Box 
                                sx={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'space-between',
                                    p: 2,
                                    mb: 3,
                                    backgroundColor: '#F8FAFC',
                                    border: '1px solid #F1F5F9',
                                    borderRadius: '10px'
                                }}
                            >
                                <Typography sx={{ fontSize: '13.5px', fontWeight: 600, color: '#1E293B', lineHeight: 1.4 }}>
                                    {message}
                                </Typography>
                                <Switch 
                                    checked={updateFlag}
                                    name="is_update_shipment"
                                    onChange={event => handleChange(event, "switch")}
                                    color="primary"
                                    sx={{ ml: 2 }}
                                />
                            </Box>

                            {/* Trigger Event Action Radio Selection Matrix Section */}
                            <Stack spacing={1.5} sx={{ px: 0.5 }}>
                                <FormLabel 
                                    id="demo-controlled-radio-buttons-group"
                                    sx={{ 
                                        color: '#64748B', 
                                        fontWeight: 700, 
                                        fontSize: '11px', 
                                        textTransform: 'uppercase', 
                                        letterSpacing: '0.5px',
                                        '&.Mui-focused': { color: '#64748B' }
                                    }}
                                >
                                    Event on
                                </FormLabel>
                                
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={(onCreateFlag === true) ? 'create_shipment' : 'manifest_close'}
                                    onChange={event => handleChange(event, "radio")}
                                    sx={{ gap: 1 }}
                                >
                                    <FormControlLabel 
                                        value="create_shipment" 
                                        disabled={!updateFlag} 
                                        control={<Radio size="small" />} 
                                        label={
                                            <Typography sx={{ fontSize: '13.5px', fontWeight: 500, color: !updateFlag ? '#94A3B8' : '#334155' }}>
                                                Create shipment
                                            </Typography>
                                        } 
                                        sx={{
                                            m: 0,
                                            p: 1.25,
                                            borderRadius: '8px',
                                            border: '1px solid',
                                            borderColor: (onCreateFlag && updateFlag) ? '#E0F2FE' : '#E2E8F0',
                                            backgroundColor: (onCreateFlag && updateFlag) ? '#F0F9FF' : 'transparent',
                                            transition: 'all 0.15s ease-in-out',
                                            '&:hover': {
                                                backgroundColor: !updateFlag ? 'transparent' : ((onCreateFlag) ? '#E0F2FE' : '#F8FAFC')
                                            }
                                        }}
                                    />
                                    <FormControlLabel 
                                        value="manifest_close" 
                                        disabled={!updateFlag} 
                                        control={<Radio size="small" />} 
                                        label={
                                            <Typography sx={{ fontSize: '13.5px', fontWeight: 500, color: !updateFlag ? '#94A3B8' : '#334155' }}>
                                                Manifest close
                                            </Typography>
                                        } 
                                        sx={{
                                            m: 0,
                                            p: 1.25,
                                            borderRadius: '8px',
                                            border: '1px solid',
                                            borderColor: (onCloseFlag && updateFlag) ? '#E0F2FE' : '#E2E8F0',
                                            backgroundColor: (onCloseFlag && updateFlag) ? '#F0F9FF' : 'transparent',
                                            transition: 'all 0.15s ease-in-out',
                                            '&:hover': {
                                                backgroundColor: !updateFlag ? 'transparent' : ((onCloseFlag) ? '#E0F2FE' : '#F8FAFC')
                                            }
                                        }}
                                    />
                                </RadioGroup>
                            </Stack>

                        </FormGroup>
                    </CardContent>
                </Card>
            </Box>
        </>
    )
}

export default ShipmentUpdateFlag;